var _circle, _g, _circle2, _circle3, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 114,
    viewBox: "0 0 118 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 59,
    r: 55,
    fill: "#F1F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14883_67186)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 91,
    r: 15,
    fill: "#D9D9D9"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#A0A8EC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 109.5,
    r: 4.5,
    fill: "#A0A8EC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_14883_67186)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 10,
    r: 10,
    fill: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.3906 39.084H51.8872C49.3672 39.084 47.3242 41.1269 47.3242 43.6469V67.9826C47.3242 70.5026 49.3672 72.5455 51.8872 72.5455H64.055L76.2832 80.6976C76.837 81.0668 77.5646 80.5964 77.4551 79.9399L76.2228 72.5455H88.3906C90.9106 72.5455 92.9536 70.5026 92.9536 67.9826V43.6468C92.9536 41.1268 90.9106 39.084 88.3906 39.084Z",
    fill: "#A0A8EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3065 33H39.7192C37.1992 33 35.1562 35.043 35.1562 37.563V61.8986C35.1562 64.4186 37.1992 66.4615 39.7192 66.4615H56.45L53.9156 76.5988C53.7433 77.2879 54.5261 77.8161 55.1006 77.3983L70.1386 66.4615H82.3065C84.8265 66.4615 86.8694 64.4186 86.8694 61.8986V37.563C86.8694 35.043 84.8266 33 82.3065 33Z",
    fill: "#4251DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3653 43.6466H45.8023C44.9616 43.6466 44.2812 42.9655 44.2812 42.1255C44.2812 41.2855 44.9616 40.6045 45.8023 40.6045H50.3653C51.206 40.6045 51.8863 41.2855 51.8863 42.1255C51.8863 42.9655 51.206 43.6466 50.3653 43.6466Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2234 43.6466H56.4507C55.61 43.6466 54.9297 42.9655 54.9297 42.1255C54.9297 41.2855 55.61 40.6045 56.4507 40.6045H76.2234C77.0641 40.6045 77.7445 41.2855 77.7445 42.1255C77.7445 42.9655 77.0641 43.6466 76.2234 43.6466Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2219 51.2521H45.8023C44.9616 51.2521 44.2812 50.571 44.2812 49.731C44.2812 48.891 44.9616 48.21 45.8023 48.21H76.2219C77.0627 48.21 77.743 48.891 77.743 49.731C77.743 50.571 77.0627 51.2521 76.2219 51.2521Z",
    fill: "#A0A8EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.575 58.8565H45.8023C44.9616 58.8565 44.2812 58.1755 44.2812 57.3355C44.2812 56.4955 44.9616 55.8145 45.8023 55.8145H65.575C66.4157 55.8145 67.096 56.4955 67.096 57.3355C67.096 58.1755 66.4157 58.8565 65.575 58.8565Z",
    fill: "#A0A8EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2227 58.8565H71.6597C70.819 58.8565 70.1387 58.1755 70.1387 57.3355C70.1387 56.4955 70.819 55.8145 71.6597 55.8145H76.2227C77.0634 55.8145 77.7437 56.4955 77.7437 57.3355C77.7437 58.1755 77.0634 58.8565 76.2227 58.8565Z",
    fill: "#A0A8EC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14883_67186",
    x: 2.56344,
    y: 70.5634,
    width: 40.8731,
    height: 40.8731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.71828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14883_67186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14883_67186",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_14883_67186",
    x: 78.5634,
    y: -5.43656,
    width: 30.8731,
    height: 30.8731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.71828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14883_67186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14883_67186",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChat);
export default __webpack_public_path__ + "static/media/empty-chat.17c5d3efc735cdeb7195bd2078f3ad86.svg";
export { ForwardRef as ReactComponent };